import * as Yup from 'yup';
import { stringRequired } from '.';

export const scheduleEmailSchema = Yup.object({
    subject: stringRequired,
    days: stringRequired,
    hours: stringRequired,
    minutes: stringRequired,
    message: stringRequired
});
export const scheduleSMSSchema = Yup.object({
    days: stringRequired,
    hours: stringRequired,
    minutes: stringRequired,
    message: stringRequired
});


export const scheduleEmailConfirmationSchema = Yup.object({
    subject: stringRequired,
    message: stringRequired
});


export const scheduleSMSConfirmationSchema = Yup.object({
    message: stringRequired
});